import { useSelector } from "react-redux"
import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Box } from "@mui/material";

import './workspaces.scss';
import { DashboardNavbar } from './../../component/workspaces/dashboard/navbar';
import { DashboardHeader } from './../../component/workspaces/dashboard/header';
import { Templates } from "./../../component/workspaces/pages/templates/templates";
import { Projects } from "./../../component/workspaces/pages/projects/projects";
import { WorkSpace } from "../../component/workspaces/pages/workspace/workspace";
import { Profile } from "../../component/workspaces/pages/profile/profile";
import { Preferences } from "../../component/workspaces/pages/preferences/preferences";
import { ApiKeys } from "../../component/workspaces/pages/apikeys/apikeys";
import Payment from "../../component/workspaces/pages/payment/payment"
import { Stocks } from "../../component/workspaces/pages/stocks/stocks";
import { Exports } from "../../component/workspaces/pages/exports/exports";
import { Assets } from "../../component/workspaces/pages/assets/assets";
import { Transcodes } from "../../component/workspaces/pages/transcodes/transcodes";
import { Compress } from "../../component/workspaces/pages/compress/compress";
import { VoiceClones } from "../../component/workspaces/pages/voiceclones/voiceclones";
import { DashboardTools } from "../../component/workspaces/pages/tools/dashboardTools";
import { Confetti } from "../../component/confetti/confetti";

export const DashBoard = () => {
  const loginState = useSelector((store) => store.maindata.loginState)
  const languageStrs = useSelector((store) => store.editdata.languageStrs)
  const [userData, setUserData] = useState({})
  const [confettiVisibility, setConfettiVisibility] = useState('none')
  useEffect(() => {
    let tempData = {}
    let item = localStorage.getItem('user_data');
    let hasSeenConfetti = localStorage.getItem('user_welcomed');

    if (!!item && JSON.parse(item)?.state === 'loggedin') {
      tempData = JSON.parse(item);
      if (!hasSeenConfetti) {
        setConfettiVisibility('flex');
        localStorage.setItem('user_welcomed', 'true');
        setTimeout(() => setConfettiVisibility('none'), 2000);
      }
    }
    setUserData(tempData)
  }, [loginState])

  return (
    <Box className='w-dashboard-contain'>
      <Helmet>
        <title>VIDEOO.IO | {languageStrs.dashboard}</title>
        <meta name="description"
          content="Videoo is an AI video editor with text to video, avatars, auto-subtitles, voice translations and more. Make the best videos easily and free. Try now!" />
        <link rel="canonical" href="https://videoo.io/dashboard" />
      </Helmet>
      <Box className="w-dashboard">
        <Box sx={{ display: confettiVisibility, position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999 }}>
          <Confetti />
        </Box>
        <DashboardNavbar userData={userData} />

        <Box className="dashboard-content-contain">
          <DashboardHeader userData={userData} />
          <section className="d-content-body-section">
            <Routes>
              <Route path="/stocks" element={<Stocks />} />
              <Route path="/templates" element={<Templates page='empty-project' />} />
              <Route path="/custometemplates" element={<Templates page='custometemplates' />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/workspace" element={<WorkSpace />} />
              <Route path="/exports" element={<Exports />} />
              <Route path="/assets" element={<Assets />} />
              <Route path="/compresss" element={<Compress />} />
              <Route path="/transcodes" element={<Transcodes />} />
              <Route path="/voiceclones" element={<VoiceClones />} />
              <Route path="/dashboard-tools" element={<DashboardTools />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/preferences" element={<Preferences />}></Route>
              <Route path="/apiKeys" element={<ApiKeys />}></Route>
            </Routes>
          </section>
        </Box>
      </Box >
    </Box >
  )
};
